import DataFilter from '../../components/filters/dataFilter';

/**
 * Inicializace obsahu kategorie v zadaném kontejneru
 */
export const initCategoryContent = async (container: HTMLElement) => {
  try {
    // Získání ID kategorie z atributu data
    const categoryId = container.dataset.categoryContent;

    // Pokud není ID kategorie k dispozici, ukonči funkci
    if (!categoryId) {
      console.warn('Missing attribute data-category-content');
      return;
    }

    // Načtení obsahu kategorie
    const content = await fetchCategoryContent(categoryId);

    // Vložení HTML obsahu do kontejneru
    container.innerHTML = content;

    const contentTopFeedFilter = document.querySelector(
      '[data-content-top-feed-filter]'
    ) as HTMLElement | null;

    // Inicializace filtru
    if (contentTopFeedFilter) {
      new DataFilter(contentTopFeedFilter);
    }
  } catch (error) {
    console.log('error', error);
    container.innerHTML = '<div class="error-top-feed"></div>';
  }
};

/**
 * Funkce pro načtení HTML obsahu kategorie z dané URL
 */
async function fetchCategoryContent(categoryId: string): Promise<string> {
  try {
    const response = await fetch(`/kategorie/${categoryId}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Získání HTML jako text
    const htmlText = await response.text();

    // Parsování HTML textu na DOM dokument
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');

    // Vrácení vnitřního HTML body dokumentu
    return doc.body.innerHTML;
  } catch (error) {
    console.error('Error fetching category content:', error);
    throw error;
  }
}
